var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApproved({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Approved"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved",
    clipPath: "url(#clip-Approved)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9013",
    "data-name": "Group 9013",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_353",
    "data-name": "Ellipse 353",
    cx: 18,
    cy: 18,
    r: 18,
    transform: "translate(-1 -1)",
    fill: "#8ec750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18957",
    "data-name": "Path 18957",
    d: "M-15073.868,12989.025l4.543,5.047,10.783-10.562",
    transform: "translate(15083.247 -12971.166)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 2.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproved);
export default __webpack_public_path__ + "static/media/Approved.cc49a130c2e2fb352daab6f28e440d88.svg";
export { ForwardRef as ReactComponent };